import { Umweltcheck } from '../_models/umweltcheck'

export class Umweltchecks{
    Umweltchecks : Umweltcheck[];
    loaded: boolean;
}
